/**
 * 反馈类型
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, XCancelButton, XInput, XSelect } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import FeedModal from './modal/FeedModal';
import { SearchBox, SearchItem } from '@/components/Layout';
import model from '@/reducers/system/feedbacktype/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';


class feedList extends React.PureComponent {

    state = {
        feedbackName: '',//反馈类型
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
        systemTypeEnum: [],
        systemTypeItem: {}
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', { enumName: 'IdeaBackSystemTypeEnum' }, 'POST')
            .then(res => {
                this.setState({ systemTypeEnum: res.result });
            });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, feedbackName, systemTypeItem } = this.state;
        const { getFeedbackList, } = this.props;
        this.searchCache = {
            feedBackType: feedbackName,//反馈类型
            systemType: systemTypeItem.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        getFeedbackList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ feedbackName: '', systemTypeItem: {} }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        this.props.getFeedbackList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageSize, pageNum }); // 【第5步：缓存分页状态】
    }


    // 表格操作  
    _tableAction = (item, type, value) => {
        switch (type) {
            case 'switch'://状态
                http('/?cmd=com.xqxc.api.pig.mis.biz.platform.FeedBackService.updateFeedBack', {
                    id: item.id,
                    status: (value === false) ? 0 : 1,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this.props.getFeedbackList(this.searchCache);
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });
                break;
            case 'sort':
                http('/?cmd=com.xqxc.api.pig.mis.biz.platform.FeedBackService.updateSorting', {
                    id: item.id,
                    sorting: value,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this.props.getFeedbackList(this.searchCache);
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });
                break;
        }
    }

    // 新建
    _create = () => {
        this.setState({
            currentOpenMode: 'creat'
        });
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'creat':
                return <FeedModal title='创建反馈类型' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this.props.getFeedbackList(this.searchCache);// 列表查询方法
        }
    }

    render() {
        const { feedbackName, systemTypeEnum, systemTypeItem } = this.state;
        const { feedbackList } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='反馈类型'
                                placeholder='请输入'
                                value={feedbackName}
                                bindThis={this}
                                bindName='feedbackName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='反馈渠道'
                                placeholder='请选择反馈渠道'
                                renderData={systemTypeEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={systemTypeItem.value}
                                bindThis={this}
                                bindName='systemTypeItem'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建' onClick={this._create} />
                    </div>
                    <TableContent
                        renderData={feedbackList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

feedList.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息

    feedbackList: PropTypes.object,
    getFeedbackList: PropTypes.func,//列表数据(action)
};

const mapStateToProps = (state) => {
    return {
        feedbackList: state.feedbacktype.feedbackList,
    };
};
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(feedList);
